module.exports = __webpack_public_path__ + "static/media/IPMI_LOGO_RGB_final-R_1739381210362.9b5a9484.png";